import React, { useEffect, useRef, useState } from 'react';

let mermaidInitialized = false;
let mermaidSeq = 0;

/**
 * Renders a ```mermaid fence as an SVG diagram. mermaid (~1.5MB) is
 * dynamically imported so it only loads on pages that actually use it.
 */
const Mermaid = ({ code }: { code: string }) => {
  const [svg, setSvg] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const idRef = useRef(`mermaid-diagram-${++mermaidSeq}`);

  useEffect(() => {
    let cancelled = false;
    import('mermaid')
      .then(async (mod) => {
        const mermaid = mod.default;
        if (!mermaidInitialized) {
          mermaid.initialize({ startOnLoad: false, theme: 'neutral' });
          mermaidInitialized = true;
        }
        const { svg: rendered } = await mermaid.render(idRef.current, code);
        if (!cancelled) setSvg(rendered);
      })
      .catch((err) => {
        console.error('mermaid render failed:', err);
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [code]);

  if (error) {
    return (
      <pre className="mermaid-fallback">
        <code>{code}</code>
      </pre>
    );
  }
  if (!svg) return <div className="mermaid-loading">Rendering diagram…</div>;
  return <div className="mermaid-diagram" dangerouslySetInnerHTML={{ __html: svg }} />;
};

export default Mermaid;
